import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { LinkButton, UIHeading1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import { Item } from './Item';
import pic1 from './static/pic1.svg';
import pic2 from './static/pic2.svg';
import pic3 from './static/pic3.svg';
import * as styles from './styles.css';
import { trackHowItWorksShow, trackValInfoClick } from '../../analytics';

interface IHowItWorksProps {
  className?: string;
}

export const HowItWorks: React.VFC<IHowItWorksProps> = ({ className }) => {
  return (
    <ActionAfterViewObserver callback={trackHowItWorksShow} callbackDelay={1500} wrapper={false}>
      <div className={cn(styles['content'], className)} data-name="how_it_works">
        <UIHeading1 as="h2">Как это работает</UIHeading1>
        <div className={styles['container_list']}>
          <Item text="Подбираем и сравниваем похожие объявления в домах поблизости" picSrc={pic1} />
          <Item text="Дорабатываем оценку с учётом десятков параметров: этаж, ремонт и другие" picSrc={pic2} />
          <Item
            text="Уточняем оценку на основе актуального тренда цен на рынке и получаем достоверный результат"
            picSrc={pic3}
          />
        </div>
        <a
          href="https://hc.cian.ru/hc/ru/articles/360032258772-%D0%9C%D0%B5%D1%82%D0%BE%D0%B4%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F-%D0%BE%D1%86%D0%B5%D0%BD%D0%BA%D0%B8"
          target="_blank"
          rel="noreferrer"
          className={styles['link']}
          onClick={trackValInfoClick}
        >
          Подробнее о методе оценки
        </a>
        <div className={styles['desktop_link']}>
          <LinkButton
            theme="fill_secondary"
            size="M"
            href="https://hc.cian.ru/hc/ru/articles/360032258772-%D0%9C%D0%B5%D1%82%D0%BE%D0%B4%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F-%D0%BE%D1%86%D0%B5%D0%BD%D0%BA%D0%B8"
            fullWidth
            onClick={trackValInfoClick}
          >
            Подробнее о методе оценки
          </LinkButton>
        </div>
      </div>
    </ActionAfterViewObserver>
  );
};
